/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import "./cart.scss";
// Redux
import { useSelector } from "react-redux";
// global funtion for store
import OrderProduct from "../OrderProduct/OrderProduct";
import { Typography } from "@material-ui/core";
import { RootState } from "../../store/reducers";
import { useTranslation, withTranslation } from "react-i18next";

const Cart = (props: any) => {
  const { t } = useTranslation();
  const { state } = props;
  const appState = useSelector((state: RootState) => state.appReducer);
  const [show, setShow] = useState<any>(false);
   useEffect(() => {
     console.log(appState?.bookingTotal)
   }, [])
   
  return (
    <div id="cart">
      <section className="mt-4">
        {state?.cart?.length > 0 && (
          <h4
            className={` yourOrderhead mb-4 familysora600  ${
              appState?.langValue === "ar" ? "text-right" : "text-left"
            }`}
          >
            {t("step3.Your-invoice")}
          </h4>
        )}
        {state?.cart?.length > 0 && state?.cart != undefined
          ? state?.cart?.map((item: any, ind: any) => (
              <div className="w-100" key={ind}>
                <OrderProduct index={ind} item={item}  />
                <hr />
              </div>
            ))
          : `
         `}

        {state?.cart?.length > 0 && (
          <React.Fragment>
            <div className="row mx-0 mt-2">
              <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center ">
                  <Typography
                    className="mx-2 my-0"
                    gutterBottom
                    variant="h5"
                    component="h2"
                  >
                    <strong className="toCapitialize d-flex familysora600">
                      Total Pre-order
                    </strong>
                  </Typography>
                </div>
                <div className="d-flex align-items-center ">
                  <Typography
                    className={`mx-2 my-0  ${
                      appState.langValue === "ar" ? `direction-ltr` : ""
                    }`}
                    gutterBottom
                    variant="h5"
                    component="h2"
                  >
                    <strong className="toCapitialize d-flex familysora600">
                      {appState?.bookingTotal?.cartTotal.toFixed(2)} KD
                    </strong>
                  </Typography>
                </div>
              </div>
            </div>
            <hr />
          </React.Fragment>
        )}
        <div className="row mx-0 mt-2">
          <div className="col-12 px-0 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center ">
              <Typography
                className={`mx-2 my-0 ${
                  state.bookingTotal?.diffGuestPrices?.length > 0
                    ? "cursorPointer"
                    : ""
                }`}
                gutterBottom
                variant="h5"
                component="h2"
                onClick={
                  state.bookingTotal?.diffGuestPrices?.length > 0
                    ? () => setShow(!show)
                    : undefined
                }
              >
                <strong className="toCapitialize d-flex familysora600">
                  {t("custom-msg.Reservation-Fee")}
                </strong>
              </Typography>
            </div>
            <div className="d-flex align-items-center ">
              <Typography
                className={`mx-2 my-0  ${
                  appState.langValue === "ar" ? `direction-ltr` : ""
                } ${
                  state.bookingTotal?.diffGuestPrices?.length > 0
                    ? "cursorPointer"
                    : ""
                }`}
                gutterBottom
                variant="h5"
                component="h2"
                onClick={
                  state.bookingTotal?.diffGuestPrices?.length > 0
                    ? () => setShow(!show)
                    : undefined
                }
              >
                <strong className="toCapitalize d-flex familySora600">
                  {appState?.bookingTotal?.reservationFee === 0 ? (
                    t("custom-msg.free")
                  ) : (
                    <>{appState?.bookingTotal?.reservationFee.toFixed(2)} KD</>
                  )}
                </strong>
              </Typography>
            </div>
          </div>
          {state.bookingTotal?.diffGuestPrices?.length > 0 &&
            state.bookingTotal?.diffGuestPrices?.map(
              (item: any, index: any) => (
                <div
                  className={`col-12 px-0 d-flex justify-content-between align-items-center ${
                    show ? `show-class` : `hide-class`
                  }`}
                >
                  <div className="d-flex align-items-center px-1">
                    <Typography
                      className="mx-2 my-0 guest_pricing"
                      gutterBottom
                    >
                      <strong className="toCapitialize d-flex familysora600">
                        {/* {t("custom-msg.Reservation-Fee")}    */}
                        {item.title}
                      </strong>
                    </Typography>
                  </div>
                  <div className="d-flex align-items-center ">
                    <Typography
                      className={`mx-2 my-0 guest_pricing  ${
                        appState.langValue === "ar" ? `direction-ltr` : ""
                      }`}
                      gutterBottom
                    >
                      <strong className="toCapitalize d-flex familySora600">
                        {appState?.bookingTotal?.reservationFee === 0 ? (
                          t("custom-msg.free")
                        ) : (
                          <>{item?.price.toFixed(2)} KD</>
                        )}
                      </strong>
                    </Typography>
                  </div>
                </div>
              )
            )}
        </div>
        <hr />
        <div className="row mx-0 mt-2">
          <div className="col-12 px-0 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center ">
              <Typography
                className={`mx-2 my-0  ${
                  appState.langValue === "ar" ? `direction-ltr` : ""
                }`}
                gutterBottom
                variant="h5"
                component="h2"
              >
                <strong className="toCapitialize d-flex familysora600">
                  {t("Total")}
                </strong>
              </Typography>
            </div>
            <div className="d-flex align-items-center ">
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                className={`mx-2 my-0  ${
                  appState.langValue === "ar" ? `direction-ltr` : ""
                }`}
              >
                <strong className="toCapitialize d-flex familysora600">
                  {Number(appState?.bookingTotal?.sumOfTotal).toFixed(2)} KD
                </strong>
              </Typography>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withTranslation()(Cart);
